<template>
  <v-container>
    <v-card>
      <v-card-title>Grupos en el periodo vigente </v-card-title>
      <v-card-subtitle> Consulta </v-card-subtitle>
    </v-card>

    <grupos-agregados :grupos="grupos" />

    <v-card
      ><v-card-text
        >Si deseas agregar grupos al periodo vigente, por favor hazlo pulsando
        el botón Añadir en la opción de Periodos.</v-card-text
      ></v-card
    >
  </v-container>
</template>

<script>
import api from "@/api";
import fn from "@/fn";
import GruposAgregados from "@/components/GruposAgregados";
import { gets } from "@/mixins/gets";

export default {
  name: "Grupos",

  components: { GruposAgregados },

  mixins: [gets],

  data: () => ({
    periodo: {},
    grupos: {},
  }),

  computed: {},

  methods: {},

  async mounted() {
    this.$store.commit("setPageTitle", "Grupos");
    this.periodo = await this.get("periodos", "actual");
    if (this.periodo) this.grupos = await this.getGrupos(this.periodo.id);
  },
};
</script>